<template>
    <MainContainer>
        <template v-slot:sidebar>&nbsp;</template>
        <div class="statuserweiterung">
            <h2>
                Statuserweiterungen
                <b-button :size="size" @click="dataCreate">
                    Neu
                    <font-awesome-icon icon="plus" />
                </b-button>
            </h2>
            <Table
                bordered
                striped
                small
                showFilter
                :fields="fields"
                :items="items"
                :isBusy="busy"
                :sortBy="sortBy"
                :sortDesc="sortDesc"
                busyText="Lädt Statuserweiterungen..."
                emptyText="Keine Statuserweiterungen gefunden"
            >
                <template v-slot:actions="{ row: row }">
                    <b-button
                        v-if="row.id && checkRight('write')"
                        :size="size"
                        @click="dataSelected(row)"
                        variant="link"
                        class="mv-table-action-btn mr-1"
                        >Bearbeiten</b-button
                    >
                    <b-button
                        v-if="row.id && checkRight('delete')"
                        :size="size"
                        @click="dataDelete(row)"
                        variant="link"
                        class="text-danger mv-table-action-btn"
                        >Löschen</b-button
                    >
                </template>
            </Table>
            <EditModal
                :title="selected.title"
                :busy="selected.busy"
                button-text="Speichern"
                @ok="dataProvide"
                @hide="dataHide"
            >
                <b-form-group
                    v-if="selected.data"
                    label-cols-sm="4"
                    label-cols-lg="3"
                    label="ID"
                    label-for="id"
                    disabled
                >
                    <b-form-input
                        id="id"
                        :value="selected.data.id"
                        :size="size"
                        readonly
                    />
                </b-form-group>
                <b-form-group
                    v-if="selected.data"
                    label-cols-sm="4"
                    label-cols-lg="3"
                    description="Name der Statuserweiterung"
                    label-for="bezeichnung"
                    :state="ioFields.bezeichnung.valid"
                >
                    <template v-slot:invalid-feedback>
                        {{ ioFields.bezeichnung.invalidFeedback }}
                    </template>

                    <template v-slot:label>
                        Bezeichnung
                        <span class="text-danger">*</span>
                    </template>

                    <b-form-input
                        id="bezeichnung"
                        v-model="selected.data.bezeichnung"
                        :size="size"
                        :state="ioFields.bezeichnung.valid"
                    />
                </b-form-group>
            </EditModal>
            <RemoveModal
                :title="selected.title"
                :busy="selected.busy"
                @ok="dataProvide"
                @hide="dataHide"
            />
        </div>
    </MainContainer>
</template>

<script>
import CommonView from "@/mixins/CommonView/CommonView";
import Size from "@/mixins/Size/Size";
import Validation from "@/mixins/Validation/Validation";
import { ApiFactory } from "@/api/ApiFactory.js";
import MainContainer from "@/components/MainContainer/MainContainer";
import Table from "@/components/Table/Table";
import EditModal from "@/components/EditModal/EditModal";
import RemoveModal from "@/components/RemoveModal/RemoveModal";

const StatuserweiterungApi = ApiFactory.get("statuserweiterung");

export default {
    name: "statuserweiterung",
    mixins: [CommonView, Size, Validation],
    components: {
        MainContainer,
        Table,
        EditModal,
        RemoveModal
    },
    data() {
        return {
            fields: [
                {
                    key: "id",
                    label: "ID",
                    sortable: true
                },
                {
                    key: "bezeichnung",
                    label: "Bezeichnung",
                    sortable: true
                },
                {
                    key: "actions",
                    label: "Funktionen",
                    class: "text-center"
                }
            ],
            ioFields: {
                bezeichnung: {}
            },
            api: StatuserweiterungApi,
            sortBy: "bezeichnung",
            sortDesc: false,
            modalTitle: "Datensatz bearbeiten"
        };
    },
    methods: {
        fetchErrorHandling(response) {
            this.handleValidationData(response, this.ioFields);
        },
        postDataSet() {
            this.cleanValidationData(this.ioFields);
        }
    }
};
</script>
